import { ActivationEnd, NavigationStart, RouterLink } from '@angular/router';
import { filter, startWith, of, switchMap, take } from 'rxjs';
export const isActiveRouterLinkFactory = (router, exact = true) => {
  return link => {
    const tree = link instanceof RouterLink ? link.urlTree : link;
    return router.isActive(tree, {
      paths: exact ? 'exact' : 'subset',
      queryParams: exact ? 'exact' : 'subset',
      fragment: 'ignored',
      matrixParams: 'ignored'
    });
  };
};
// angular extra router state data access
// DURING routing it can be fetched using Router.getCurrentNavigation().extra.state.
// This is ONLY true for routed component constructor. 
// Child components will be created AFTER routing.
// AFTER routing, the state is simply available through window history object.
export function getCurrentRouteState() {
  return window.history.state;
}
export function urlTreeToString(tree) {
  const segments = tree.root.children.primary.segments;
  return segments.map(s => s.path).join('/');
}
// A utility to solve a difficulty of NG Router:
// router will emit multiple ActivationEnd events, starting with the deepest Route,
// then going up until reaching the root route.
// we need to filter for the FIRST ActivationEnd event and skip the following ones.
// then we need to wait for NavigationEnd
// ActivationEnd will be emitted several times depending on depth of route.
// to fix, set activationHandled to true and skip further ActivationEnd events.
// Listen to NavigationEnd and reset the variable then.
export function observeInnermostActivationEnd(router, includeInitial = true) {
  return router.events.pipe(filter(e => e instanceof NavigationStart), includeInitial ? startWith(of(true)) : v => v,
  // manual trigger is required for first routing, because NavigationStart will have already been fired in moment of component construction
  switchMap(() => {
    return router.events.pipe(filter(e => e instanceof ActivationEnd), take(1));
  }));
}